/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

  function fixHeaderNavigation(navbar) {
    var sticky = navbar.offsetTop;
    if (window.pageYOffset > sticky) {
      navbar.classList.add("fixed-nav");
    } else {
      navbar.classList.remove("fixed-nav");
    }
  }

  var navbar = document.querySelector(".navigation");

  if (navbar) {
    window.onscroll = function () {
      fixHeaderNavigation(navbar);
    };
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function () {
        // JavaScript to be fired on all pages
        try {

        } catch (err) {
          $.noop();
        }
      },
      finalize: function () {
        // JavaScript to be fired on all pages, after page specific JS is fired
        try {

        } catch (e) {
          console.log(e);
        }
      }
    },
    // Home page
    'home': {
      init: function () {
        // JavaScript to be fired on the home page
      },
      finalize: function () {
        // JavaScript to be fired on the home page, after the init JS
      }
    },
    // About us page, note the change from about-us to about_us.
    'about_us': {
      init: function () {
        // JavaScript to be fired on the about us page
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function (func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function () {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);
  if (navigator.userAgent.match(/(iPhone|iPod|iPad|Android|BlackBerry)/)) {
    if (window.location.origin.indexOf("neumarkt") > -1) {
      $(".header-logo img").prop("src", "/wp-content/themes/krivec-site/dist/images/Logo_Apotheke-am-Neumarkt_mobile.png");
    }
    if (window.location.origin.indexOf("muehlen") > -1) {
      $(".header-logo img").prop("src", "/wp-content/themes/krivec-site/dist/images/Logo_Muehlen_Apotheke_mobile.png");
    }
    if (window.location.origin.indexOf("brunnen") > -1) {
      $(".header-logo img").prop("src", "/wp-content/themes/krivec-site/dist/images/Logo_Brunnen_Apotheke_mobile.png");
    }
    if (window.location.origin.indexOf("aeskulap") > -1) {
      $(".header-logo img").prop("src", "/wp-content/themes/krivec-site/dist/images/Logo_Aeskulap_Apotheke_mobile.png");
    }
  }
  var $mmenu = $('#navigation-main'), $html = $('html, body');

  $mmenu.mmenu({

    extensions: ["theme-white", "pagedim-black", "effect-slide-menu", "effect-listitems-slide", "border-full"],
    offCanvas: {
      moveBackground: false,
      position: "left",
      zposition: "front"
    },
    navbar: {
      add: false
    },
    navbars: [
      {
        position: "top",
        content: ['']
      }
    ],
    slidingSubmenus: false
  }, {

      offCanvas: {
        pageSelector: "> div:not(#wpadminbar)"
      },
      clone: true
    }).removeClass('invisible');

  $("#gototop").click(function (e) {
    e.preventDefault();
    $('body,html').animate({
      scrollTop: 0
    }, 800);
  });

  $(".medikamentevorbestellen  > a").click(function () {
    $("#vorbestellungModal").modal("show");
  });

  $("ul.sub-menu li.external a").click(function (e) {
    e.preventDefault();
    var url = $(this).prop("href");
    window.location = url.replace(window.location.origin, "https://3036145.digitale-apo.com/");
  });

})(jQuery); // Fully reference jQuery after this point.
